import { takeLatest, put, call } from 'redux-saga/effects';
import { getListCustoInsumos } from '../service';
import { formatDateDDMMYYYY } from '@components/common/format';
import {
    CONFIG_SESSION,
    CUSTO_LIST_INSUMOS,
    CUSTO_LIST_INSUMOS_PENDING,
    CUSTO_LIST_INSUMOS_SUCCESS,
    CUSTO_LIST_INSUMOS_FAILURE,
} from '@handler';
import { storage } from '@commons/storage';

function* fetchListCustoInsumos(action) {
  yield put({ type: CUSTO_LIST_INSUMOS_PENDING });

  try {
    const session = JSON.parse(storage.get(CONFIG_SESSION));
    const idFazenda = session.fazendaSelecionada?.id ?? -1;
    const idSafra = session.safraAtiva?.id ?? -1;
    const dataInicial = formatDateDDMMYYYY(action.dataInicial);
    const dataFinal = formatDateDDMMYYYY(action.dataFinal);

    const dadosListCustosInsumos = yield call(getListCustoInsumos, idFazenda, idSafra, dataInicial, dataFinal);
    yield put({ type: CUSTO_LIST_INSUMOS_SUCCESS, dadosListCustosInsumos });
  } catch (err) {
    yield put({ type: CUSTO_LIST_INSUMOS_FAILURE });
  }
}

export default function* watchListCustoInsumos() {
  yield takeLatest(CUSTO_LIST_INSUMOS, fetchListCustoInsumos);
}
